import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Mobile from '../../Components/Mobile';
import Assistant, { DesktopPanel } from '../../Components/Assistant';
import PinnedConversation from '../../Components/Admin/PinnedConversation';
import Analytics from '../../Components/Analytics';
import Status from '../../Components/Offline/Status';
import VoIPWrapper from '../../Components/Voip';
import RedesignAnnouncements from '../../Components/Session/RedesignAnnouncements';
import TabletNav from './Nav';

const TabletLayout = () => {
    return (
        <div className="min-h-screen w-full bg-blue-50 dark:bg-gray-900 p-2 pb-4">
            <ErrorBoundary fullPage={true}>
                <DialoguesWrapper>
                    <RedesignAnnouncements />
                    <HelpWrapper>
                        <Mobile>
                            <VoIPWrapper>
                                <Assistant>
                                    <TabletNav />

                                    <div className="h-[calc(100dvh-1.5rem)] w-full flex flex-col">

                                        <Status className="mb-2 shrink-0 rounded-xl py-1 text-center text-xs" />

                                        <div className="relative min-h-0 flex-1 overflow-hidden rounded-xl surface-1 shadow-lg dark:shadow-none w-full mx-auto">
                                            <ErrorBoundary>
                                                <Outlet />
                                            </ErrorBoundary>
                                        </div>
                                    </div>

                                    <DesktopPanel />
                                    <PinnedConversation />
                                </Assistant>
                            </VoIPWrapper>
                        </Mobile>
                    </HelpWrapper>
                </DialoguesWrapper>

                <Analytics />
            </ErrorBoundary>
        </div>
    );
};

export default TabletLayout;
